(() => {
"use strict";
const clamp=(v,a=0,b=1)=>v<a?a:v>b?b:v;
const lerp=(a,b,t)=>a+(b-a)*t;
const RM=matchMedia("(prefers-reduced-motion: reduce)").matches;

/* ---------- hero headline: word-by-word reveal ---------- */
const H=document.getElementById("h1");
"Seven days.".split(" ").forEach((word,i)=>{
  const s=document.createElement("span");
  s.className="w"; s.textContent=word;
  s.style.animationDelay=(0.25+i*0.09)+"s";
  H.appendChild(s);
});
/* line two carries the gradient. Its fill is a background clipped to the
   text, so it can't hold opacity-animated children — animate the <em>. */
const em=document.createElement("em");
em.className="late"; em.style.animationDelay=".5s"; em.textContent="One turn.";
H.appendChild(em);

/* ---------- colourways (blue = the DoseTrack brand blue) ---------- */
const WAYS={
  blue:  {label:"Blue",  a1:"#5BC0E8",a2:"#1F8FC4",a3:"#136B96",tint:"#E6F5FC"},
  violet:{label:"Purple",a1:"#A98BF5",a2:"#6D3FD4",a3:"#5227B0",tint:"#F1ECFE"},
  orange:{label:"Orange",a1:"#FFA05C",a2:"#EE5F1B",a3:"#C74A11",tint:"#FFF1E7"}
};

/* ---------- the 3D stage ---------- */
let stage=null;
const canvas=document.getElementById("gl");
try{
  if(!document.createElement("canvas").getContext("webgl2")) throw new Error("no webgl2");
  stage=createStage(canvas,{onDay,hdr:typeof HDR_B64!=="undefined"?HDR_B64:null});
}catch(e){
  document.documentElement.classList.add("no-webgl");
  console.warn("WebGL unavailable, using the still image:",e.message);
}

/* ---------- the scroll act ----------
   One timeline drives camera, lid, carousel, drawer and explode.
   Keyframes are in act-progress (0 = top of hero, 1 = end of colour). */
const K=[
 /* -- 1. ORBIT -- the product turns a full circle, closed --------------- */
 {p:0.000, camZ:6.60, camY:0.46, oy:-0.92, ox: 0.00, orbit:-0.60, tilt:0.44, scale:1.00,
           fill:1, lid:0, turn:0, press:0, drawer:0, eject:0, explode:0},
 {p:0.075, camZ:6.20, camY:0.40, oy:-0.62, ox: 0.00, orbit: 1.50, tilt:0.36, scale:1.00,
           fill:1, lid:0, turn:0, press:0, drawer:0, eject:0, explode:0},
 {p:0.140, camZ:5.60, camY:0.44, oy:-0.20, ox:-0.30, orbit: 3.60, tilt:0.42, scale:1.02,
           fill:1, lid:0, turn:0, press:0, drawer:0, eject:0, explode:0},
 {p:0.190, camZ:5.20, camY:0.70, oy:-0.30, ox:-0.44, orbit: 5.68, tilt:0.70, scale:1.02,
           fill:0, lid:0, turn:0, press:0, drawer:0, eject:0, explode:0},

 /* -- 2. FILL -- lid lifts aside, pills drop into all seven wedges ------ */
 {p:0.250, camZ:5.05, camY:1.15, oy:-0.34, ox:-0.44, orbit: 6.28, tilt:1.02, scale:1.02,
           fill:0, lid:1, turn:0, press:0, drawer:0, eject:0, explode:0},
 {p:0.400, camZ:5.05, camY:1.22, oy:-0.34, ox:-0.44, orbit: 6.60, tilt:1.08, scale:1.02,
           fill:1, lid:1, turn:0, press:0, drawer:0, eject:0, explode:0},

 /* -- 3. CLOSE -- the lid comes back down ------------------------------- */
 {p:0.470, camZ:5.05, camY:0.95, oy:-0.22, ox:-0.44, orbit: 6.90, tilt:0.88, scale:1.02,
           fill:1, lid:0, turn:0, press:0, drawer:0, eject:0, explode:0},

 /* -- 4. TRAVEL -- it orbits again and crosses the frame ---------------- */
 {p:0.560, camZ:5.30, camY:0.44, oy: 0.16, ox: 0.44, orbit: 8.60, tilt:0.34, scale:1.00,
           fill:1, lid:0, turn:0, press:0, drawer:0, eject:0, explode:0},

 /* -- 5. DISPENSE -- latch opens, button presses, the week turns -------- */
 {p:0.620, camZ:4.95, camY:0.58, oy: 0.24, ox: 0.34, orbit: 7.98, tilt:0.36, scale:1.00,
           fill:1, lid:0, turn:0, press:1, drawer:1, eject:0, explode:0},
 {p:0.800, camZ:4.90, camY:0.55, oy: 0.26, ox: 0.34, orbit: 8.10, tilt:0.34, scale:1.00,
           fill:1, lid:0, turn:1, press:0, drawer:1, eject:1, explode:0},

 /* -- 6. APART -- the four parts separate, then settle back ------------- */
 {p:0.890, camZ:7.40, camY:0.72, oy:-0.16, ox: 0.30, orbit: 9.30, tilt:0.60, scale:0.96,
           fill:0, lid:1, turn:1, press:0, drawer:1, eject:1, explode:1},
 {p:0.960, camZ:5.90, camY:0.44, oy:-0.10, ox: 0.00, orbit:10.30, tilt:0.40, scale:1.00,
           fill:1, lid:0, turn:1, press:0, drawer:0, eject:0, explode:0},
 {p:1.000, camZ:5.60, camY:0.40, oy:-0.14, ox: 0.00, orbit:10.80, tilt:0.38, scale:1.00,
           fill:1, lid:0, turn:1, press:0, drawer:0, eject:0, explode:0}
];
const FIELDS=["camZ","camY","ox","oy","orbit","tilt","scale","fill","lid","turn","press","drawer","eject","explode"];
function sample(p){
  let i=0; while(i<K.length-2 && p>K[i+1].p) i++;
  const a=K[i], b=K[i+1];
  const t=clamp((p-a.p)/(b.p-a.p||1));
  const s=t*t*(3-2*t);                       // smoothstep between keyframes
  const out={};
  for(const f of FIELDS) out[f]=lerp(a[f],b[f],s);
  return out;
}

const act=document.querySelector(".act");
const stageEl=document.getElementById("stage");
/* ?p=0.42 pins the timeline to a fixed point — used to review a single
   beat of the choreography without scrolling. No effect without the param. */
const LOCK=(()=>{const v=new URLSearchParams(location.search).get("p");
  return v===null?null:clamp(parseFloat(v));})();
function actProgress(){
  if(LOCK!==null) return LOCK;
  const total=act.offsetHeight-innerHeight;
  return total>0 ? clamp(scrollY/total) : 0;
}

/* ---------- week copy + day rail ---------- */
const DAYS=["01","02","03","04","05","06","07"];
const rail=document.getElementById("rail");
rail.innerHTML=DAYS.map(d=>`<b><span></span>${d}</b>`).join("");
const railEls=[...rail.children];
const countEl=document.getElementById("count");
const copies=[...document.querySelectorAll(".wc")];
let copyShown=-1;

function onDay(d){
  railEls.forEach((el,i)=>{
    el.classList.toggle("on",i===d);
    el.classList.toggle("done",i<d);
  });
  countEl.textContent=String(d+1).padStart(2,"0");
}
onDay(0);

/* ---------- main loop ---------- */
const nav=document.getElementById("nav");
function tick(){
  const p=actProgress();
  if(stage){
    stage.set(sample(p));
    stage.frame();
  }
  /* the stage fades out once the copy sections take over */
  stageEl.style.opacity = p>0.985 ? String(clamp(1-(p-0.985)/0.015)) : "1";

  const ci = p>0.545 ? 2 : p>0.315 ? 1 : 0;
  if(ci!==copyShown){
    copyShown=ci;
    copies.forEach((c,i)=>c.classList.toggle("on",i===ci));
  }
  nav.classList.toggle("solid",scrollY>40);
  requestAnimationFrame(tick);
}
function onResize(){ if(stage) stage.resize(); }
/* when a beat is pinned for review, settle the easing before first paint */
if(LOCK!==null && stage){ stage.set(sample(LOCK)); for(let i=0;i<120;i++) stage.frame(); }
addEventListener("resize",onResize,{passive:true});
onResize(); requestAnimationFrame(tick);

/* ---------- reveals below the act ---------- */
const io=new IntersectionObserver(es=>{
  es.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add("in"); io.unobserve(e.target); }});
},{threshold:.16,rootMargin:"0px 0px -8% 0px"});
document.querySelectorAll(".rv").forEach(el=>io.observe(el));

const notif=document.getElementById("notif");
new IntersectionObserver(es=>{
  es.forEach(e=>{ if(e.isIntersecting) setTimeout(()=>notif.classList.add("in"),520); });
},{threshold:.4}).observe(document.getElementById("phone"));

/* ---------- colourway ---------- */
const chips=document.getElementById("chips"), chipName=document.getElementById("chipName");
chips.innerHTML=Object.entries(WAYS).map(([k,v])=>
  `<button class="chip" data-way="${k}" aria-pressed="${k==="violet"}" aria-label="${v.label}"
     style="background:linear-gradient(145deg,${v.a1},${v.a3});color:${v.a2}"></button>`).join("");
function setWay(k){
  const v=WAYS[k], s=document.documentElement.style;
  s.setProperty("--a1",v.a1); s.setProperty("--a2",v.a2);
  s.setProperty("--a3",v.a3); s.setProperty("--tint",v.tint);
  chipName.textContent=v.label;
  chips.querySelectorAll(".chip").forEach(c=>
    c.setAttribute("aria-pressed",String(c.dataset.way===k)));
  document.querySelectorAll("#buyFig img").forEach(i=>
    i.classList.toggle("on",i.dataset.way===k));
}
chips.addEventListener("click",e=>{
  const b=e.target.closest(".chip"); if(b) setWay(b.dataset.way);
});
setWay("violet");


/* ---------- buy (wired to the Shopify cart) ---------- */
const VMAP   = JSON.parse(document.getElementById("dt-variants").textContent);
const ROUTES = JSON.parse(document.getElementById("dt-routes").textContent);
const CODE = {blue:"BLU", violet:"PUR", orange:"ORG"};
const RANK = {BLU:0, PUR:1, ORG:2};
const PAIR = {BLU:"B", PUR:"P", ORG:"O"};
let tier = "one", way2 = "blue";

const opts   = document.getElementById("opts");
const price  = document.getElementById("price");
const pairEl = document.getElementById("pair");
const chips2 = document.getElementById("chips2");
const cta    = document.getElementById("cta");
const msg    = document.getElementById("buyMsg");

chips2.innerHTML = Object.entries(WAYS).map(([k,v]) =>
  `<button class="chip" data-way="${k}" aria-pressed="${k===way2}" aria-label="${v.label}"
     style="background:linear-gradient(145deg,${v.a1},${v.a3});color:${v.a2}"></button>`).join("");

chips2.addEventListener("click", e => {
  const b = e.target.closest(".chip"); if(!b) return;
  way2 = b.dataset.way;
  chips2.querySelectorAll(".chip").forEach(c =>
    c.setAttribute("aria-pressed", String(c.dataset.way === way2)));
  sync();
});

function currentWay(){
  const on = chips.querySelector('.chip[aria-pressed="true"]');
  return on ? on.dataset.way : "violet";
}

/* the ten live variants are flat SKUs; rebuild the SKU from the selection */
function sku(){
  if (tier === "three") return "DT-ORG-3-SET";
  if (tier === "one")   return "DT-ORG-1-" + CODE[currentWay()];
  const a = CODE[currentWay()], b = CODE[way2];
  const [x,y] = RANK[a] <= RANK[b] ? [a,b] : [b,a];
  return "DT-ORG-2-" + PAIR[x] + PAIR[y];
}

function money(cents){
  const s = (cents/100).toFixed(2);
  return "A$" + s.replace(/\.00$/, "");
}

function sync(){
  pairEl.hidden = tier !== "two";
  const v = VMAP[sku()];
  if (v) {
    price.textContent = money(v.price);
    cta.disabled = !v.available;
    msg.textContent = v.available ? "" : "That combination is sold out.";
  } else {
    cta.disabled = true;
    msg.textContent = "That combination isn't available.";
  }
}

opts.addEventListener("click", e => {
  const b = e.target.closest(".opt"); if(!b) return;
  [...opts.children].forEach(o => o.setAttribute("aria-pressed", String(o === b)));
  tier = b.dataset.tier;
  sync();
});

/* setWay's own listener is registered first, so aria-pressed is already
   updated by the time this runs */
chips.addEventListener("click", () => sync());

cta.addEventListener("click", async function(){
  const v = VMAP[sku()]; if(!v) return;
  const label = this.textContent;
  this.disabled = true; this.textContent = "Adding…";
  try {
    const r = await fetch(ROUTES.cartAdd + ".js", {
      method: "POST",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify({items:[{id: v.id, quantity: 1}]})
    });
    const data = await r.json();
    if (!r.ok) throw new Error(data.description || "Could not add to cart");
    this.textContent = "Added ✓";
    msg.innerHTML = '<a href="' + ROUTES.cart + '" style="color:var(--a2)">View bag &rarr;</a>';
    setTimeout(() => { this.textContent = label; this.disabled = false; }, 1600);
  } catch (err) {
    this.textContent = label; this.disabled = false;
    msg.textContent = err.message;
  }
});

sync();
})();
